<template>
  <v-container fluid>
    <v-card>
      <v-tabs v-model="tab" bg-color="primary" @change="(v) => changeTab(v)">
        <v-tab value="one">线路列表</v-tab>
        <v-tab value="three">车企信息</v-tab>
        <v-tab value="four">挂厢信息</v-tab>
        <v-tab value="two">投资测算(电车)</v-tab>
        <v-tab value="five">投资测算(油车)</v-tab>
      </v-tabs>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="queryForm.name" label="线路名称" dense outlined clearable hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <a-space>
                  <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
                    <v-icon small>mdi-magnify</v-icon> 查询
                  </v-btn>
                  <v-btn color="primary" tile @click="getdata()">
                    <v-icon small>mdi-refresh</v-icon> 刷新
                  </v-btn>
                  <v-btn color="success" tile @click="showadd">
                    <v-icon small>mdi-plus</v-icon> 新增线路
                  </v-btn>
                </a-space>
              </v-col>
            </v-row>
            <a-table size="small" :columns="headers" :data-source="list" row-key="_id" :pagination="false"
              :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }">
              <template slot="operation" slot-scope="text, record">
                <a-space>
                  <v-btn text tile small color="info" @click="changeTab(2, { _id: record._id })"> 投资测算 </v-btn>
                </a-space>
              </template>
              <template slot="index" slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
              <template slot="T_day_tcount_day_fcount">
                <p class="success--text">日均趟次(趟)</p>
                <p class="error--text">日发班次(班)</p>
              </template>
              <template slot="day_tcount_day_fcount" slot-scope="text, record">
                <p class="success--text">{{ record.day_tcount }}</p>
                <p class="error--text">{{ record.day_fcount }}</p>
              </template>
              <template slot="T_tincome_tbridge_cost">
                <p class="success--text">单班运输收入(元)</p>
                <p class="error--text">单趟运输路桥费(元)</p>
              </template>
              <template slot="tincome_tbridge_cost" slot-scope="text, record">
                <p class="success--text">{{ record.tincome }}</p>
                <p class="error--text">{{ record.tbridge_cost }}</p>
              </template>
              <template slot="T_loading_time_require_aging">
                <p>装车用时(小时)</p>
                <p>时效要求(小时)</p>
              </template>
              <template slot="loading_time_require_aging" slot-scope="text, record">
                <p>{{ record.loading_time || '-' }}</p>
                <p>{{ record.require_aging || '-' }}</p>
              </template>
              <template slot="action" slot-scope="text, record">
                <a-space>
                  <v-btn text tile small color="success" @click="showedit(record)"> 编辑 </v-btn>
                  <v-btn text tile small color="cyan" @click="copy([record._id])"> 复制 </v-btn>
                  <a-popconfirm title="确认删除线路?" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)"
                    placement="left">
                    <v-btn text tile small color="error"> 删除 </v-btn>
                  </a-popconfirm>
                </a-space>
              </template>
              <template slot="expandedRowRender" slot-scope="record" style="margin: 0">
                <a-table size="small" :columns="sheaders" :data-source="record.items" :pagination="false"
                  :locale="{ emptyText: '暂无数据' }" :scroll="{ x: swidth }" row-key="_id">
                  <template slot="index" slot-scope="text, record, index">
                    {{ index + 1 }}
                  </template>
                  <template slot="action" slot-scope="text, record">
                    <a-space>
                      <a href="javascript:void(0);"
                        @click="changeTab(2, { _id: record._id, lineid: record.lineid })">编辑</a>
                      <a href="javascript:void(0);" class="cyan--text" @click="copydetail(record._id)"> 复制 </a>
                    </a-space>
                  </template>
                </a-table>
              </template>
            </a-table>
            <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" xl="2" lg="3" md="6" sm="12">
                <v-select v-model="cqQueryForm.B" :items="Bs" label="车型" :menu-props="{ bottom: true, offsetY: true }"
                  no-data-text="无" dense outlined clearable hide-details>
                </v-select>
              </v-col>
              <v-col cols="12" xl="2" lg="3" md="6" sm="12">
                <v-select v-model="cqQueryForm.C" :items="Cs" label="驱动形式" :menu-props="{ bottom: true, offsetY: true }"
                  no-data-text="无" dense outlined clearable hide-details>
                </v-select>
              </v-col>
              <v-col cols="12" xl="2" lg="3" md="6" sm="12">
                <a-space>
                  <v-btn color="primary" tile style="color:#fff;" @click="getcqdata()">
                    <v-icon small>mdi-magnify</v-icon> 查询
                  </v-btn>
                  <v-btn color="primary" tile @click="getcqdata">
                    <v-icon small>mdi-refresh</v-icon> 刷新
                  </v-btn>
                  <v-btn color="success" tile @click="cqadd">
                    <v-icon small>mdi-plus</v-icon> 新增车企数据
                  </v-btn>
                  <v-btn color="primary" tile @click="cqbadd">
                    <v-icon small>mdi-cog</v-icon> 管理车企
                  </v-btn>
                </a-space>
              </v-col>
            </v-row>
            <a-table size="small" :columns="cqheaders" :data-source="cqlist" :pagination="false"
              :locale="{ emptyText: '暂无数据' }" :scroll="{ x: cqwidth, y: height }" row-key="_id">
              <template slot="index" slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
              <template slot="action" slot-scope="text, record">
                <a-space>
                  <v-btn text tile color="success" @click="cqedit(record)"> 编辑 </v-btn>
                  <a-popconfirm title="确认删除数据?" ok-text="确定" cancel-text="取消" @confirm="cqremove(record._id)"
                    placement="left">
                    <v-btn text tile color="error"> 删除 </v-btn>
                  </a-popconfirm>
                </a-space>
              </template>
            </a-table>
            <v-pagination v-if="cqlength > 1" v-model="cqpage" :page="cqpage" :length="cqlength" total-visible="10" />
          </v-tab-item>
          <v-tab-item>
            <div class="d-flex justify-space-between mb-2">
              <v-btn color="primary" tile @click="gethangboxdata">
                <v-icon small>mdi-refresh</v-icon> 刷新
              </v-btn>
              <a-space>
                <v-btn color="success" tile @click="hangboxadd">
                  <v-icon small>mdi-plus</v-icon> 新增挂箱
                </v-btn>
              </a-space>
            </div>
            <a-table size="small" :columns="hangboxheaders" :data-source="hangboxlist" :pagination="false"
              :locale="{ emptyText: '暂无数据' }" :scroll="{ x: hangboxwidth, y: height }" row-key="_id">
              <template slot="index" slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
              <template slot="action" slot-scope="text, record">
                <a-space>
                  <v-btn text tile color="success" @click="hangboxedit(record)"> 编辑 </v-btn>
                  <a-popconfirm title="确认删除数据?" ok-text="确定" cancel-text="取消" @confirm="hangboxremove(record._id)"
                    placement="left">
                    <v-btn text tile color="error"> 删除 </v-btn>
                  </a-popconfirm>
                </a-space>
              </template>
            </a-table>
            <v-pagination v-if="hangboxlength > 1" v-model="hangboxpage" :page="hangboxpage" :length="hangboxlength"
              total-visible="10" />
          </v-tab-item>
          <v-tab-item>
            <v-form ref="calcform" v-model="calcvalid" lazy-validation>
              <h2 class="pa-2">
                <span class="red--text">{{ lineform.name }}</span>线路
              </h2>
              <v-autocomplete v-model="lineform._id" :items="lines" label="线路"
                :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined hide-details
                @change="changeline">
              </v-autocomplete>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-sheet class="ma-2">
                    <a-descriptions title="线路信息" bordered size="small" :column="2">
                      <a-descriptions-item label="线路名称">
                        {{ lineform.name }}
                      </a-descriptions-item>
                      <a-descriptions-item label="运距">
                        {{ C5 }} km
                      </a-descriptions-item>
                      <a-descriptions-item label="日均趟次">
                        {{ C6 }} 次
                      </a-descriptions-item>
                      <a-descriptions-item label="日发班次">
                        {{ C7 }} 班
                      </a-descriptions-item>
                      <a-descriptions-item label="年运输天数">
                        {{ C8 }} 天
                      </a-descriptions-item>
                      <a-descriptions-item label="运营年限">
                        {{ lineform.service_year }} 年
                      </a-descriptions-item>
                      <a-descriptions-item label="单趟运输路桥费">
                        <span class="red--text">{{ C9 }}</span> 元
                      </a-descriptions-item>
                      <a-descriptions-item label="单班运输收入">
                        <span class="success--text">{{ C10 }}</span> 元
                      </a-descriptions-item>
                    </a-descriptions>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        车辆信息
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-select v-model="detailform.vehicle_brand" :items="vehicle_brands2"
                              :rules="[vrules.required]" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无"
                              dense outlined :disabled="saving || !lineform._id" hide-details
                              @change="changeVehicleBrand">
                              <template v-slot:label>
                                <span>车企品牌</span>
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-select v-model="detailform.vehicle_type" :items="vehicle_types"
                              :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>车型</span>
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.battery_capacity" type="number" suffix="kWh" outlined
                              dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>电池容量</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.working_condition_endurance" type="number" suffix="km"
                              outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>工况续航</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.vehicle_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">单车采购价 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.vehicle_count" :rules="[vrules.required]" type="number"
                              suffix="辆" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">购车数量 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        运营数据
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="C21" type="number" suffix="km" outlined dense readonly
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>单车日运营里程</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="C22" type="number" suffix="km" outlined dense readonly
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>单车年运营里程</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.km_usepower" type="number" suffix="kWh" outlined dense
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">单车每公里耗电 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="C25" type="number" suffix="kWh" outlined dense readonly
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>单车年耗电量</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="C26" type="number" suffix="kWh" outlined dense readonly
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>年总耗电量</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.electricity_price" :rules="[vrules.required]"
                              type="number" suffix="元/kWh" outlined dense :disabled="saving || !lineform._id"
                              hide-details>
                              <template v-slot:label>
                                <span class="red--text">平均电价 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.charge_service_price" :rules="[vrules.required]"
                              type="number" suffix="元/kWh" outlined dense :disabled="saving || !lineform._id"
                              hide-details>
                              <template v-slot:label>
                                <span class="red--text">充电服务费单价 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                </v-col>
                <v-col cols="6">
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        车辆成本
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.annual_depreciation_rate" :rules="[vrules.required]"
                              type="number" suffix="%" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">年折旧率 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G10" type="number" suffix="元" outlined dense readonly
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>车辆年折旧</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.G11_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">车辆保险(/车/年)*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.G12_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">年审、营运证(/车/年)*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G13" type="number" suffix="元" outlined dense readonly
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>车辆购置税</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        运营成本
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G4" type="number" suffix="元" outlined dense readonly
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>充换电服务费</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G5" type="number" suffix="元" outlined dense readonly
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>电费</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G6" type="number" suffix="元" outlined dense readonly
                              :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span>路桥费</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.G7_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">车辆保养(/车/年)*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.G8_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">轮胎更换(/车/年)*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        人力成本
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.G14_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">司机工资(/月) *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.G15_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">车队管理人员工资(/月) *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.G16_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">补贴、福利等（/月）*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        其他成本
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform.other_cost1" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving || !lineform._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">其他(罚款、意外事故、装卸辅助等)</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        线路预测（投资回报周期）
                      </v-card-title>
                      <v-card-text>
                        <div class="form basic">
                          <v-row>
                            <v-col cols="12" md="4">
                              <a-statistic title="总投入(元)" :value="F28" style="margin-right: 50px" />
                            </v-col>
                            <v-col cols="12" md="4">
                              <a-statistic title="年收入(元)" :value="G20" style="margin-right: 50px" />
                            </v-col>
                            <v-col cols="12" md="4">
                              <a-statistic title="年成本(元)" :value="G19" style="margin-right: 50px" />
                            </v-col>
                            <v-col cols="12" md="4">
                              <a-statistic title="年利润(元)" :value="G21" style="margin-right: 50px" />
                            </v-col>
                            <v-col cols="12" md="4">
                              <a-statistic title="投资回报年限(年)" :value="F30_" :formatter="({ h, value }) => {
                                if (value > 0) return value;
                                else return '-';
                              }" style="margin-right: 50px" />
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                </v-col>
              </v-row>
              <v-btn class="mt-4" color="default" block :disabled="!calcvalid || !lineform._id"
                @click="savecalcresult">保存</v-btn>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form ref="calcform5" v-model="calcvalid5" lazy-validation>
              <h2 class="pa-2">
                <span class="red--text">{{ lineform5.name }}</span>线路
              </h2>
              <v-autocomplete v-model="lineform5._id" :items="lines" label="线路"
                :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined hide-details
                @change="changeline5">
              </v-autocomplete>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-sheet class="ma-2">
                    <a-descriptions title="线路信息" bordered size="small" :column="2">
                      <a-descriptions-item label="线路名称">
                        {{ lineform5.name }}
                      </a-descriptions-item>
                      <a-descriptions-item label="运距">
                        {{ C5_5 }} km
                      </a-descriptions-item>
                      <a-descriptions-item label="日均趟次">
                        {{ C6_5 }} 次
                      </a-descriptions-item>
                      <a-descriptions-item label="日发班次">
                        {{ C7_5 }} 班
                      </a-descriptions-item>
                      <a-descriptions-item label="年运输天数">
                        {{ C8_5 }} 天
                      </a-descriptions-item>
                      <a-descriptions-item label="运营年限">
                        {{ lineform5.service_year }} 年
                      </a-descriptions-item>
                      <a-descriptions-item label="单趟运输路桥费">
                        <span class="red--text">{{ C9_5 }}</span> 元
                      </a-descriptions-item>
                      <a-descriptions-item label="单班运输收入">
                        <span class="success--text">{{ C10_5 }}</span> 元
                      </a-descriptions-item>
                    </a-descriptions>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        车辆信息
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-select v-model="detailform5.vehicle_brand" :items="vehicle_brands5"
                              :rules="[vrules.required]" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无"
                              dense outlined :disabled="saving5 || !lineform5._id" hide-details
                              @change="changeVehicleBrand5">
                              <template v-slot:label>
                                <span>车企品牌</span>
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-select v-model="detailform5.vehicle_type" :items="vehicle_types"
                              :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" dense outlined
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>车型</span>
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.battery_capacity" type="number" suffix="kWh" outlined
                              dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>电池容量</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.working_condition_endurance" type="number" suffix="km"
                              outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>工况续航</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.vehicle_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">单车采购价 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.vehicle_count" :rules="[vrules.required]" type="number"
                              suffix="辆" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">购车数量 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        运营数据
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="C21_5" type="number" suffix="km" outlined dense readonly
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>单车日运营里程</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="C22_5" type="number" suffix="km" outlined dense readonly
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>单车年运营里程</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.km_usepower" type="number" suffix="kWh" outlined dense
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">单车每公里耗电 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="C25_5" type="number" suffix="kWh" outlined dense readonly
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>单车年耗电量</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="C26_5" type="number" suffix="kWh" outlined dense readonly
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>年总耗电量</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.electricity_price" :rules="[vrules.required]"
                              type="number" suffix="元/kWh" outlined dense :disabled="saving5 || !lineform5._id"
                              hide-details>
                              <template v-slot:label>
                                <span class="red--text">平均电价 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.charge_service_price" :rules="[vrules.required]"
                              type="number" suffix="元/kWh" outlined dense :disabled="saving5 || !lineform5._id"
                              hide-details>
                              <template v-slot:label>
                                <span class="red--text">充电服务费单价 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                </v-col>
                <v-col cols="6">
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        车辆成本
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.annual_depreciation_rate" :rules="[vrules.required]"
                              type="number" suffix="%" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">年折旧率 *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G10_5" type="number" suffix="元" outlined dense readonly
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>车辆年折旧</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.G11_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">车辆保险(/车/年)*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.G12_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">年审、营运证(/车/年)*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G13_5" type="number" suffix="元" outlined dense readonly
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>车辆购置税</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        运营成本
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G4_5" type="number" suffix="元" outlined dense readonly
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>充换电服务费</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G5_5" type="number" suffix="元" outlined dense readonly
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>电费</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="G6_5" type="number" suffix="元" outlined dense readonly
                              :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span>路桥费</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.G7_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">车辆保养(/车/年)*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.G8_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">轮胎更换(/车/年)*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        人力成本
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.G14_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">司机工资(/月) *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.G15_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">车队管理人员工资(/月) *</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.G16_price" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">补贴、福利等（/月）*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        其他成本
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="detailform5.other_cost1" :rules="[vrules.required]" type="number"
                              suffix="元" outlined dense :disabled="saving5 || !lineform5._id" hide-details>
                              <template v-slot:label>
                                <span class="red--text">其他(罚款、意外事故、装卸辅助等)</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-sheet class="ma-2">
                    <v-card>
                      <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4">
                        线路预测（投资回报周期）
                      </v-card-title>
                      <v-card-text>
                        <div class="form basic">
                          <v-row>
                            <v-col cols="12" md="4">
                              <a-statistic title="总投入(元)" :value="F28_5" style="margin-right: 50px" />
                            </v-col>
                            <v-col cols="12" md="4">
                              <a-statistic title="年收入(元)" :value="G20_5" style="margin-right: 50px" />
                            </v-col>
                            <v-col cols="12" md="4">
                              <a-statistic title="年成本(元)" :value="G19_5" style="margin-right: 50px" />
                            </v-col>
                            <v-col cols="12" md="4">
                              <a-statistic title="年利润(元)" :value="G21_5" style="margin-right: 50px" />
                            </v-col>
                            <v-col cols="12" md="4">
                              <a-statistic title="投资回报年限(年)" :value="F30_5" :formatter="({ h, value }) => {
                                if (value > 0) return value;
                                else return '-';
                              }" style="margin-right: 50px" />
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                </v-col>
              </v-row>
              <v-btn class="mt-4" color="default" block :disabled="!calcvalid5 || !lineform5._id"
                @click="savecalcresult5">保存</v-btn>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    <v-dialog v-model="model" persistent :width="600">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y:auto;">
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="form.name" :rules="[vrules.required]" placeholder="线路名称" dense outlined
                    :disabled="saving">
                    <template v-slot:label>
                      线路名称<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.km" :rules="[vrules.required]" type="number" suffix="km" dense outlined
                    :disabled="saving">
                    <template v-slot:label>
                      运距<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.day_tcount" :rules="[vrules.required]" type="number" suffix="次" dense
                    outlined :disabled="saving">
                    <template v-slot:label>
                      日均趟次<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.day_fcount" :rules="[vrules.required]" type="number" suffix="班" dense
                    outlined :disabled="saving">
                    <template v-slot:label>
                      日发班次<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.year_tdays" :rules="[vrules.required]" type="number" suffix="天" dense
                    outlined :disabled="saving">
                    <template v-slot:label>
                      年运输天数<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.service_year" :rules="[vrules.required]" type="number" suffix="年" outlined
                    dense :disabled="saving" hide-details>
                    <template v-slot:label>
                      运营年限<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.tbridge_cost" :rules="[vrules.required]" type="number" suffix="元" dense
                    outlined :disabled="saving">
                    <template v-slot:label>
                      <span class="red--text">单趟运输路桥费 *</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.tincome" :rules="[vrules.required]" type="number" suffix="元" dense
                    outlined :disabled="saving">
                    <template v-slot:label>
                      <span class="red--text"><span class="success--text">单班运输收入</span> *</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40"
                    :return-value.sync="form.departure_time" transition="scale-transition" offset-y max-width="290px"
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.departure_time" append-icon="mdi-clock-time-four-outline" dense
                        outlined readonly v-bind="attrs" v-on="on">
                        <template v-slot:label>
                          发车时间
                        </template>
                      </v-text-field>
                    </template>
                    <v-time-picker v-if="menu" v-model="form.departure_time" format="24hr" no-title scrollable
                      full-width @click:minute="$refs.menu.save(form.departure_time)"></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.loading_time" type="number" suffix="小时" dense outlined :disabled="saving">
                    <template v-slot:label>
                      装车用时
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.require_aging" type="number" suffix="小时" dense outlined
                    :disabled="saving">
                    <template v-slot:label>
                      时效要求
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.remark" label="备注" rows="3" outlined dense :disabled="saving"></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <a-modal :title="cqtitle" :visible="cqmodal" @ok="cqsave" okText="确定" @cancel="cqcancelsave" cancelText="取消"
      width="60%">
      <a-form-model ref="cqformref" :model="cqform" :rules="cqrules" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="车企" prop="A">
              <a-select v-model="cqform.A" :options="vehicle_brands" placeholder="请选择" size="large" style="width:100%;">
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="车型" prop="B">
              <a-input v-model="cqform.B" placeholder="车型" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="驱动形式" prop="C">
              <a-input v-model="cqform.C" placeholder="驱动形式" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="电池型号" prop="D">
              <a-input v-model="cqform.D" placeholder="电池型号" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="电池质保" prop="E">
              <a-input v-model="cqform.E" placeholder="电池质保" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="电量" prop="F">
              <a-input v-model="cqform.F" type="number" placeholder="电量(kWh)" suffix="kWh" size="large"
                style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="最大载重" prop="G">
              <a-input v-model="cqform.G" type="number" placeholder="最大载重(吨)" suffix="吨" size="large"
                style="width:100%;" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="续航里程" prop="H">
              <a-input v-model="cqform.H" type="number" placeholder="续航里程(KM)" suffix="KM" size="large"
                style="width:100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="单公里能耗" prop="I">
              <a-input v-model="cqform.I" type="number" placeholder="单公里能耗(kWh)" suffix="kWh" size="large"
                style="width:100%;" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="最高车速" prop="J">
              <a-input v-model="cqform.J" type="number" placeholder="最高车速" size="large" style="width:100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="充电时长" prop="K">
              <a-input v-model="cqform.K" placeholder="充电时长" size="large" style="width:100%;" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="整车价格" prop="L">
              <a-input v-model="cqform.L" type="number" placeholder="价格(万元)" suffix="万元" size="large"
                style="width:100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="电池租赁(3年)" prop="L1">
              <a-input v-model="cqform.L1" type="number" placeholder="价格(万元)" suffix="万元" size="large"
                style="width:100%;" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="交付周期" prop="M">
              <a-input v-model="cqform.M" placeholder="交付周期" size="large" style="width:100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="优惠力度" prop="N" :labelCol="{ span: 4 }" :wrapperCol="{ span: 19 }">
              <a-textarea v-model="cqform.N" placeholder="优惠力度" size="large" rows="3" style="width:100%;">
              </a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <a-modal :title="cqbtitle" :visible="cqbmodal" @ok="cqbsave" okText="确定" @cancel="cqbcancelsave" cancelText="取消"
      width="400px">
      <a-form-model ref="cqbformref" :model="cqbform" :rules="cqbrules" :labelCol="{ span: 8 }"
        :wrapperCol="{ span: 14 }">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="车企" prop="vehicle_brands" :labelCol="{ span: 4 }" :wrapperCol="{ span: 19 }">
              <a-textarea v-model="cqbform.vehicle_brands" placeholder="车企" rows="15" style="width:100%;">
              </a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <a-modal :title="hangboxtitle" :visible="hangboxmodal" :confirm-loading="saving" @ok="hangboxsave" okText="确定"
      @cancel="hangboxcancelsave" cancelText="取消" width="60%">
      <a-form-model ref="hangboxformref" :model="hangboxform" :rules="hangboxrules" :labelCol="{ span: 8 }"
        :wrapperCol="{ span: 14 }">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="厂家名称" prop="A">
              <a-input v-model="hangboxform.A" placeholder="厂家名称" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="型号" prop="B">
              <a-input v-model="hangboxform.B" placeholder="型号" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="类型" prop="C">
              <a-input v-model="hangboxform.C" placeholder="类型" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="使用年限" prop="D">
              <a-input v-model="hangboxform.D" type="number" placeholder="使用年限" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="价格(万元)" prop="E">
              <a-input v-model="hangboxform.E" type="number" placeholder="价格(万元)" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="交付周期" prop="F">
              <a-input v-model="hangboxform.F" placeholder="交付周期" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="数量" prop="H">
              <a-input v-model="hangboxform.H" type="number" placeholder="数量" size="large" style="width:100%;">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="备注" prop="G">
              <a-textarea v-model="hangboxform.G" placeholder="备注" size="large" rows="3" style="width:100%;">
              </a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </v-container>
</template>

<script>
import _ from "underscore";
import { message } from "ant-design-vue";
import { mapState } from "vuex";

export default {
  name: "Costcal",
  data() {
    return {
      headers: [
        { title: "操作", dataIndex: "operation", scopedSlots: { customRender: "operation" }, width: 100, align: "center" },
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "线路名称", dataIndex: "name", scopedSlots: { customRender: "name" }, width: 180, align: "center" },//XXX-XXX
        { title: "运距(km)", dataIndex: "km", scopedSlots: { customRender: "km" }, width: 100, align: "center" },
        { dataIndex: "day_tcount_day_fcount", slots: { title: "T_day_tcount_day_fcount" }, scopedSlots: { customRender: "day_tcount_day_fcount" }, width: 100, align: "center" },
        { title: "年运输天数(天)", dataIndex: "year_tdays", scopedSlots: { customRender: "year_tdays" }, width: 120, align: "center" },
        { title: "运营年限", dataIndex: "service_year", scopedSlots: { customRender: "service_year" }, width: 120, align: "center" },
        { dataIndex: "tincome_tbridge_cost", slots: { title: "T_tincome_tbridge_cost" }, scopedSlots: { customRender: "tincome_tbridge_cost" }, width: 150, align: "center" },
        { title: "发车时间", dataIndex: "departure_time", scopedSlots: { customRender: "departure_time" }, width: 100, align: "center" },
        { dataIndex: "loading_time_require_aging", slots: { title: "T_loading_time_require_aging" }, scopedSlots: { customRender: "loading_time_require_aging" }, width: 120, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 150, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 200, align: "center" },
      ],
      sheaders: [
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 100, align: "center" },
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "车企品牌", dataIndex: "vehicle_brand", scopedSlots: { customRender: "vehicle_brand" }, width: 100, align: "center" },
        { title: "购车数量(辆)", dataIndex: "vehicle_count", scopedSlots: { customRender: "vehicle_count" }, width: 100, align: "center" },
        { title: "购车价格(元)", dataIndex: "vehicle_price_", scopedSlots: { customRender: "vehicle_price_" }, width: 100, align: "center" },
        { title: "车辆成本(元)", dataIndex: "vehicle_cost", scopedSlots: { customRender: "vehicle_cost" }, width: 100, align: "center" },
        { title: "运营成本(元)", dataIndex: "operate_cost", scopedSlots: { customRender: "operate_cost" }, width: 150, align: "center" },
        { title: "人力成本(元)", dataIndex: "labor_cost", scopedSlots: { customRender: "labor_cost" }, width: 150, align: "center" },
        { title: "其他成本(元)", dataIndex: "other_cost", scopedSlots: { customRender: "other_cost" }, width: 150, align: "center" },
        { title: "总成本(元)", dataIndex: "year_cost_", scopedSlots: { customRender: "year_cost_" }, width: 120, align: "center" },
        { title: "利润(元)", dataIndex: "year_profit_", scopedSlots: { customRender: "year_profit_" }, width: 120, align: "center" },
        { title: "投资回报年限(年)", dataIndex: "investment_return_years_", scopedSlots: { customRender: "investment_return_years_" }, width: 150, align: "center" },
      ],
      queryForm: {
        name: "",
      },
      selectedRowKeys: [],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      vehicle_types: [],
      vehicle_brands: [],
      height: 600,
      vrules: {
        required: (value) => !!value || "不能为空"
      },
      valid: true,
      model: false,
      modeltitle: "",
      form: {},
      menu: false,
      saving: false,
      tab: 0,
      lines: [],
      lineform: {
        _id: "",
        name: "",//线路名称
        km: "",//运距(km) <!--! C5
        day_tcount: "",//日均趟次 <!--! C6
        day_fcount: "",//日发班次 <!--! C7
        year_tdays: "",//年运输天数 <!--! C8
        service_year: "",//运营年限
        tbridge_cost: "",//单趟运输路桥费(元) <!--! C9
        tincome: "",//单班运输收入(元) <!--! C10
      },
      detailform: {
        _id: "",
        vehicle_type: "",//车型
        battery_capacity: "",//电池容量(kWh)
        working_condition_endurance: "",//工况续航(km)
        vehicle_price: "",//单车采购价(元) <!--! C17
        vehicle_count: "",//购车数量(辆) <!--! C18
        vehicle_brand: "",//车企品牌
        day_km: "",//单车日运营里程(km) <!--@ C21=C5*C6
        year_km: "",//单车年运营里程(km) <!--@ C22=C21*C8
        km_usepower: "",//单车每公里耗电(kWh) <!--! C23
        year_usepower: "",//单车年耗电量(kWh) <!--@ C25=C22*C23
        year_totalpower: "",//年总耗电量(kWh) <!--@ C26=C25*C18
        electricity_price: "",//平均电价(元/kWh) <!--! C24
        charge_service_price: "",//充电服务费单价(元/kWh) <!--! C27
        annual_depreciation_rate: "",//年折旧率 <!--! R28
        vehicle_depreciation: "",//车辆年折旧(元) <!--@ G10=C17*C18*R28/100
        G11_price: "15000",
        vehicle_insurance: "",//车辆保险(元) <!--@ G11=C18*15000
        G12_price: "1500",
        anisp_op: "",//年审、运营证(元) <!--@ G12=C18*1500
        vehicle_purchase_tax: "",//车辆购置税 <!--@ G13=C17*C18*0.113
        charge_service_fee: "",//充电服务费(元) <!--@ G4=C26*C27
        electricity_fee: "",//电费(元) <!--@ G5=C26*C24
        road_bridge_fee: "",//路桥费(元) <!--@ G6=C6*C7*C8*C9
        G7_price: "3000",
        vehicle_maintenance_fee: "",//车辆保养(元) <!--@ G7=C18*3000
        G8_price: "10000",
        tire_replacement_fee: "",//轮胎更换(元) <!--@ G8=C18*10000
        G14_price: "7000",
        driver_salary: "",//司机工资(元) <!--@ G14=C7*7000*12
        G15_price: "12000",
        manager_salary: "",//车队管理人员工资(元) <!--!@ G15=G15_price*12
        G16_price: "1000",
        subsidy_benefits: "",//补贴、福利等(元) <!--@ G16=C7*1000*12
        other_cost1: "",//其他(罚款、意外事故、装卸辅助等)(元) <!--! G18

        initial_investment: "",//前期投入(元) <!--@ F28=C17*C18
        year_income: "",//年收入(元) <!--@ G20=C6*C7*C8*C10
        year_cost: "",//年成本(元) <!--@ G19=G4+G5+G6+G7+G8+G11+G12+G13/service_year+G17+G18
        year_profit: "",//年利润(元) <!--@ G21=G20-G19
        investment_return_years: "",//投资回报年限(年) <!--# F30=F28/G21
      },
      calcform: {
        G7_price: "3000",
        G8_price: "10000",
        G11_price: "15000",
        G12_price: "1500",
        G14_price: "7000",
        G15_price: "12000",
        G16_price: "1000",
      },
      calcvalid: true,
      vehicle_brands2: [],
      // 油车投资测算（独立数据，字段结构与电车一致，后续按需调整）
      lineform5: {
        _id: "",
        name: "",//线路名称
        km: "",//运距(km)
        day_tcount: "",//日均趟次
        day_fcount: "",//日发班次
        year_tdays: "",//年运输天数
        service_year: "",//运营年限
        tbridge_cost: "",//单趟运输路桥费(元)
        tincome: "",//单班运输收入(元)
      },
      detailform5: {
        _id: "",
        vehicle_type: "",//车型
        battery_capacity: "",//电池容量(kWh)
        working_condition_endurance: "",//工况续航(km)
        vehicle_price: "",//单车采购价(元)
        vehicle_count: "",//购车数量(辆)
        vehicle_brand: "",//车企品牌
        day_km: "",//单车日运营里程(km)
        year_km: "",//单车年运营里程(km)
        km_usepower: "",//单车每公里耗电(kWh)
        year_usepower: "",//单车年耗电量(kWh)
        year_totalpower: "",//年总耗电量(kWh)
        electricity_price: "",//平均电价(元/kWh)
        charge_service_price: "",//充电服务费单价(元/kWh)
        annual_depreciation_rate: "",//年折旧率
        vehicle_depreciation: "",//车辆年折旧(元)
        G11_price: "15000",
        vehicle_insurance: "",//车辆保险(元)
        G12_price: "1500",
        anisp_op: "",//年审、运营证(元)
        vehicle_purchase_tax: "",//车辆购置税
        charge_service_fee: "",//充电服务费(元)
        electricity_fee: "",//电费(元)
        road_bridge_fee: "",//路桥费(元)
        G7_price: "3000",
        vehicle_maintenance_fee: "",//车辆保养(元)
        G8_price: "10000",
        tire_replacement_fee: "",//轮胎更换(元)
        G14_price: "7000",
        driver_salary: "",//司机工资(元)
        G15_price: "12000",
        manager_salary: "",//车队管理人员工资(元)
        G16_price: "1000",
        subsidy_benefits: "",//补贴、福利等(元)
        other_cost1: "",//其他(元)
        initial_investment: "",//前期投入(元)
        year_income: "",//年收入(元)
        year_cost: "",//年成本(元)
        year_profit: "",//年利润(元)
        investment_return_years: "",//投资回报年限(年)
      },
      calcform5: {
        G7_price: "3000",
        G8_price: "10000",
        G11_price: "15000",
        G12_price: "1500",
        G14_price: "7000",
        G15_price: "12000",
        G16_price: "1000",
      },
      calcvalid5: true,
      vehicle_brands5: [],
      saving5: false,
      cqQueryForm: {
        B: "",
        C: "",
      },
      Bs: [],
      Cs: [],
      cqpage: 1,
      cqlimit: 20,
      cqlist: [],
      cqlength: 0,
      cqcount: 0,
      cqmodal: false,
      cqform: {},
      cqtitle: "",
      cqheaders: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "车企", dataIndex: "A", scopedSlots: { customRender: "A" }, width: 100, align: "center" },
        { title: "车型", dataIndex: "B", scopedSlots: { customRender: "B" }, width: 100, align: "center" },
        { title: "驱动形式", dataIndex: "C", scopedSlots: { customRender: "C" }, width: 100, align: "center" },
        { title: "电池型号", dataIndex: "D", scopedSlots: { customRender: "D" }, width: 100, align: "center" },
        { title: "电池质保", dataIndex: "E", scopedSlots: { customRender: "E" }, width: 100, align: "center" },
        { title: "电量(kWh)", dataIndex: "F", scopedSlots: { customRender: "F" }, width: 100, align: "center" },
        { title: "最大载重(吨)", dataIndex: "G", scopedSlots: { customRender: "G" }, width: 100, align: "center" },
        { title: "续航里程(KM)", dataIndex: "H", scopedSlots: { customRender: "H" }, width: 100, align: "center" },
        { title: "单公里能耗(kWh)", dataIndex: "I", scopedSlots: { customRender: "I" }, width: 100, align: "center" },
        { title: "最高车速", dataIndex: "J", scopedSlots: { customRender: "J" }, width: 100, align: "center" },
        { title: "充电时长", dataIndex: "K", scopedSlots: { customRender: "K" }, width: 100, align: "center" },
        { title: "价格(万元)", dataIndex: "L", scopedSlots: { customRender: "L" }, width: 100, align: "center" },
        { title: "电池租赁(3年)", dataIndex: "L1", scopedSlots: { customRender: "L1" }, width: 120, align: "center" },
        { title: "合计(万元)", dataIndex: "LT", scopedSlots: { customRender: "LT" }, width: 120, align: "center" },
        { title: "交付周期", dataIndex: "M", scopedSlots: { customRender: "M" }, width: 100, align: "center" },
        { title: "优惠力度", dataIndex: "N", scopedSlots: { customRender: "N" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center", fixed: 'right' },
      ],
      cqrules: {
        A: [
          { required: true, message: '车企为空', trigger: 'blur' },
        ],
        F: [
          { required: true, message: '电量不能为空', trigger: 'blur' },
        ],
        H: [
          { required: true, message: '续航里程不能为空', trigger: 'blur' },
        ],
        I: [
          { required: true, message: '单公里能耗不能为空', trigger: 'blur' },
        ],
        L: [
          { required: true, message: '价格不能为空', trigger: 'blur' },
        ],
      },
      cqbmodal: false,
      cqbform: {
        vehicle_brands: [],
      },
      cqbtitle: "",
      cqbrules: {
        vehicle_brands: [
          { required: true, message: '车企', trigger: 'blur' },
        ],
      },
      hangboxpage: 1,
      hangboxlimit: 20,
      hangboxlist: [],
      hangboxlength: 0,
      hangboxcount: 0,
      hangboxmodal: false,
      hangboxform: {},
      hangboxtitle: "",
      hangboxheaders: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "厂家", dataIndex: "A", scopedSlots: { customRender: "A" }, width: 100, align: "center" },
        { title: "型号", dataIndex: "B", scopedSlots: { customRender: "B" }, width: 100, align: "center" },//牵引头挂,载货车箱
        { title: "类型", dataIndex: "C", scopedSlots: { customRender: "C" }, width: 100, align: "center" },//类型:挂厢一体、挂、厢
        { title: "使用年限", dataIndex: "D", scopedSlots: { customRender: "D" }, width: 100, align: "center" },//使用年限:新车,3年,6年
        { title: "价格(万元)", dataIndex: "E", scopedSlots: { customRender: "E" }, width: 100, align: "center" },
        { title: "交付周期", dataIndex: "F", scopedSlots: { customRender: "F" }, width: 100, align: "center" },//交付周期
        { title: "数量", dataIndex: "H", scopedSlots: { customRender: "H" }, width: 100, align: "center" },//数量
        { title: "备注", dataIndex: "G", scopedSlots: { customRender: "G" }, width: 200, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center", fixed: "right" },
      ],
      hangboxrules: {
        A: [
          { required: true, message: '厂家名称不能为空', trigger: 'blur' },
        ],
        B: [
          { required: true, message: '型号不能为空', trigger: 'blur' },
        ],
        C: [
          { required: true, message: '类型不能为空', trigger: 'blur' },
        ],
        D: [
          { required: true, message: '使用年限不能为空', trigger: 'blur' },
        ],
        E: [
          { required: true, message: '价格不能为空', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    swidth() {
      return _.reduce(this.sheaders, (a, b) => a + (b.width || 300), 0);
    },
    cqwidth() {
      return _.reduce(this.cqheaders, (a, b) => a + (b.width || 300), 0);
    },
    hangboxwidth() {
      return _.reduce(this.hangboxheaders, (a, b) => a + (b.width || 300), 0);
    },
    C5() {//运距(km) <!--! C5
      if (this.lineform.km) {
        return this.lineform.km * 1;
      }
      return "";
    },
    C6() {//日均趟次 <!--! C6
      if (this.lineform.day_tcount) {
        return this.lineform.day_tcount * 1;
      }
      return "";
    },
    C7() {//日发班次 <!--! C7
      if (this.lineform.day_fcount) {
        return this.lineform.day_fcount * 1;
      }
      return "";
    },
    C8() {//年运输天数 <!--! C8
      if (this.lineform.year_tdays) {
        return this.lineform.year_tdays * 1;
      }
      return "";
    },
    C9() {//单趟运输路桥费(元) <!--! C9
      if (this.lineform.tbridge_cost) {
        return this.lineform.tbridge_cost * 1;
      }
      return "";
    },
    C10() {//单班运输收入(元) <!--! C10
      if (this.lineform.tincome) {
        return this.lineform.tincome * 1;
      }
      return "";
    },
    C17() {//单车采购价 <!--! C17
      if (this.detailform.vehicle_price) {
        return this.detailform.vehicle_price * 1;
      }
      return "";
    },
    C18() {//购车数量 <!--! C18
      if (this.detailform.vehicle_count) {
        return this.detailform.vehicle_count * 1;
      }
      return "";
    },
    C21() {//单车日运营里程 <!--@ C21=C5*C6
      if (this.C5 !== "" && this.C6 !== "") {
        return this.$d(this.C5).times(this.C6).toString();
      }
      return "";
    },
    C22() {//单车年运营里程 <!--@ C22=C21*C8
      if (this.C21 !== "" && this.C8 !== "") {
        return this.$d(this.C21).times(this.C8).toString();
      }
      return "";
    },
    C23() {//单车每公里耗电 <!--! C23
      if (this.detailform.km_usepower) {
        return this.detailform.km_usepower * 1;
      }
      return "";
    },
    C24() {//平均电价 <!--! C24
      if (this.detailform.electricity_price) {
        return this.detailform.electricity_price * 1;
      }
      return "";
    },
    C25() {//单车年耗电量 <!--@ C25=C22*C23
      if (this.C22 !== "" && this.C23 !== "") {
        return this.$d(this.C22).times(this.C23).toString();
      }
      return "";
    },
    C26() {//年总耗电量 <!--@ C26=C25*C18
      if (this.C25 !== "" && this.C18 !== "") {
        return this.$d(this.C25).times(this.C18).toString();
      }
      return "";
    },
    C27() {//充电服务费单价 <!--! C27
      if (this.detailform.charge_service_price) {
        return this.detailform.charge_service_price * 1;
      }
      return "";
    },
    R28() {//年折旧率 <!--! R28
      if (this.detailform.annual_depreciation_rate) {
        return this.detailform.annual_depreciation_rate * 1;
      }
      return "";
    },
    G4() {//充电服务费 <!--@ G4=C26*C27
      if (this.C26 !== "" && this.C27 !== "") {
        return this.$d(this.C26).times(this.C27).toString();
      }
      return "";
    },
    G5() {//电费 <!--@ G5=C26*C24
      if (this.C26 !== "" && this.C24 !== "") {
        return this.$d(this.C26).times(this.C24).toString();
      }
      return "";
    },
    G6() {//路桥费 <!--@ G6=C6*C7*C8*C9
      if (this.C6 !== "" && this.C7 !== "" && this.C8 !== "" && this.C9 !== "") {
        return this.$d(this.C6).times(this.C7).times(this.C8).times(this.C9).toString();
      }
      return "";
    },
    G7() {//车辆保养 <!--@ G7=C18*G7_price
      if (this.C18 !== "") {
        return this.$d(this.C18).times(this.detailform.G7_price || 0).toString();
      }
      return "";
    },
    G8() {//轮胎更换 <!--@ G8=C18*G8_price
      if (this.C18 !== "") {
        return this.$d(this.C18).times(this.detailform.G8_price || 0).toString();
      }
      return "";
    },
    G10() {//车辆年折旧 <!--@ G10=C17*C18*R28/100
      if (this.C17 !== "" && this.C18 !== "" && this.R28 !== "") {
        return this.$d(this.C17).times(this.C18).times(this.R28).div(100).toString();
      }
      return "";
    },
    G11() {//车辆保险 <!--@ G11=C18*G11_price
      if (this.C18 !== "") {
        return this.$d(this.C18).times(this.detailform.G11_price || 0).toString();
      }
      return "";
    },
    G12() {//年审、运营证 <!--@ G12=C18*G12_price
      if (this.C18 !== "") {
        return this.$d(this.C18).times(this.detailform.G12_price || 0).toString();
      }
      return "";
    },
    G13() {//车辆购置税 <!--@ G13=C17*C18*0.113
      if (this.C17 !== "" && this.C18 !== "") {
        return this.$d(this.C17).times(this.C18).times("0.113").toString();
      }
      return "";
    },
    G14() {//司机工资 <!--@ G14=C7*G14_price*12
      if (this.C7 !== "") {
        return this.$d(this.C7).times(this.detailform.G14_price || 0).times(12).toString();
      }
      return "";
    },
    G15() {//车队管理人员工资 <!--!@ G15=G15_price*12
      return this.$d(this.detailform.G15_price || 0).times(12).toString();
    },
    G16() {//补贴、福利等 <!--@ G16=C7*G16_price*12
      if (this.C7 !== "") {
        return this.$d(this.C7).times(this.detailform.G16_price || 0).times(12).toString();
      }
      return "";
    },
    G17() {//人力成本 <!--@ G17=G14+G15+G16
      if (this.G14 !== "" && this.G15 !== "" && this.G16 !== "") {
        return this.$d(this.G14).plus(this.G15).plus(this.G16).toString();
      }
      return "";
    },
    G18() {//其他(罚款、意外事故、装卸辅助等) <!--! G18
      if (this.detailform.other_cost1) {
        return this.detailform.other_cost1 * 1;
      }
      return "";
    },
    G19() {//年成本 <!--@ G19=G4+G5+G6+G7+G8+G10+G11+G12+G13/service_year+G17+G18
      if (this.G4 !== "" && this.G5 !== "" && this.G6 !== "" && this.G7 !== "" && this.G8 !== "" && this.G10 !== "" && this.G11 !== "" && this.G12 !== "" && this.G13 !== "" && this.lineform.service_year !== "" && this.G17 !== "" && this.G18 !== "") {
        return this.$d(this.G4).plus(this.G5).plus(this.G6).plus(this.G7).plus(this.G8).plus(this.G10).plus(this.G11).plus(this.G12).plus(this.$d(this.G13).div(this.lineform.service_year)).plus(this.G17).plus(this.G18).toString();
      }
      return "";
    },
    G20() {//年收入 <!--@ G20=C6*C7*C8*C10
      if (this.C6 !== "" && this.C7 !== "" && this.C8 !== "" && this.C10 !== "") {
        return this.$d(this.C6).times(this.C7).times(this.C8).times(this.C10).toString();
      }
      return "";
    },
    G21() {//年利润 <!--@ G21=G20-G19
      if (this.G20 !== "" && this.G19 !== "") {
        return this.$d(this.G20).minus(this.G19).toString();
      }
      return "";
    },
    F28() {//前期投入 <!--@ F28=C17*C18
      if (this.C17 !== "" && this.C18 !== "") {
        return this.$d(this.C17).times(this.C18).toString();
      }
      return "";
    },
    F30() {//投资回报年限 <!--# F30=F28/G21
      if (this.F28 !== "" && this.G21 !== "") {
        return this.$d(this.F28).div(this.G21).toString();
      }
      return "";
    },
    F30_() {
      if (this.F30 !== "") return this.$d(this.F30).toFixed(1);
      return "";
    },
    // ===== 油车投资测算独立计算项 =====
    C5_5() { if (this.lineform5.km) return this.lineform5.km * 1; return ""; },
    C6_5() { if (this.lineform5.day_tcount) return this.lineform5.day_tcount * 1; return ""; },
    C7_5() { if (this.lineform5.day_fcount) return this.lineform5.day_fcount * 1; return ""; },
    C8_5() { if (this.lineform5.year_tdays) return this.lineform5.year_tdays * 1; return ""; },
    C9_5() { if (this.lineform5.tbridge_cost) return this.lineform5.tbridge_cost * 1; return ""; },
    C10_5() { if (this.lineform5.tincome) return this.lineform5.tincome * 1; return ""; },
    C17_5() { if (this.detailform5.vehicle_price) return this.detailform5.vehicle_price * 1; return ""; },
    C18_5() { if (this.detailform5.vehicle_count) return this.detailform5.vehicle_count * 1; return ""; },
    C21_5() { if (this.C5_5 !== "" && this.C6_5 !== "") return this.$d(this.C5_5).times(this.C6_5).toString(); return ""; },
    C22_5() { if (this.C21_5 !== "" && this.C8_5 !== "") return this.$d(this.C21_5).times(this.C8_5).toString(); return ""; },
    C23_5() { if (this.detailform5.km_usepower) return this.detailform5.km_usepower * 1; return ""; },
    C24_5() { if (this.detailform5.electricity_price) return this.detailform5.electricity_price * 1; return ""; },
    C25_5() { if (this.C22_5 !== "" && this.C23_5 !== "") return this.$d(this.C22_5).times(this.C23_5).toString(); return ""; },
    C26_5() { if (this.C25_5 !== "" && this.C18_5 !== "") return this.$d(this.C25_5).times(this.C18_5).toString(); return ""; },
    C27_5() { if (this.detailform5.charge_service_price) return this.detailform5.charge_service_price * 1; return ""; },
    R28_5() { if (this.detailform5.annual_depreciation_rate) return this.detailform5.annual_depreciation_rate * 1; return ""; },
    G4_5() { if (this.C26_5 !== "" && this.C27_5 !== "") return this.$d(this.C26_5).times(this.C27_5).toString(); return ""; },
    G5_5() { if (this.C26_5 !== "" && this.C24_5 !== "") return this.$d(this.C26_5).times(this.C24_5).toString(); return ""; },
    G6_5() { if (this.C6_5 !== "" && this.C7_5 !== "" && this.C8_5 !== "" && this.C9_5 !== "") return this.$d(this.C6_5).times(this.C7_5).times(this.C8_5).times(this.C9_5).toString(); return ""; },
    G7_5() { if (this.C18_5 !== "") return this.$d(this.C18_5).times(this.detailform5.G7_price || 0).toString(); return ""; },
    G8_5() { if (this.C18_5 !== "") return this.$d(this.C18_5).times(this.detailform5.G8_price || 0).toString(); return ""; },
    G10_5() { if (this.C17_5 !== "" && this.C18_5 !== "" && this.R28_5 !== "") return this.$d(this.C17_5).times(this.C18_5).times(this.R28_5).div(100).toString(); return ""; },
    G11_5() { if (this.C18_5 !== "") return this.$d(this.C18_5).times(this.detailform5.G11_price || 0).toString(); return ""; },
    G12_5() { if (this.C18_5 !== "") return this.$d(this.C18_5).times(this.detailform5.G12_price || 0).toString(); return ""; },
    G13_5() { if (this.C17_5 !== "" && this.C18_5 !== "") return this.$d(this.C17_5).times(this.C18_5).times("0.113").toString(); return ""; },
    G14_5() { if (this.C7_5 !== "") return this.$d(this.C7_5).times(this.detailform5.G14_price || 0).times(12).toString(); return ""; },
    G15_5() { return this.$d(this.detailform5.G15_price || 0).times(12).toString(); },
    G16_5() { if (this.C7_5 !== "") return this.$d(this.C7_5).times(this.detailform5.G16_price || 0).times(12).toString(); return ""; },
    G17_5() { if (this.G14_5 !== "" && this.G15_5 !== "" && this.G16_5 !== "") return this.$d(this.G14_5).plus(this.G15_5).plus(this.G16_5).toString(); return ""; },
    G18_5() { if (this.detailform5.other_cost1) return this.detailform5.other_cost1 * 1; return ""; },
    G19_5() { if (this.G4_5 !== "" && this.G5_5 !== "" && this.G6_5 !== "" && this.G7_5 !== "" && this.G8_5 !== "" && this.G10_5 !== "" && this.G11_5 !== "" && this.G12_5 !== "" && this.G13_5 !== "" && this.lineform5.service_year !== "" && this.G17_5 !== "" && this.G18_5 !== "") return this.$d(this.G4_5).plus(this.G5_5).plus(this.G6_5).plus(this.G7_5).plus(this.G8_5).plus(this.G10_5).plus(this.G11_5).plus(this.G12_5).plus(this.$d(this.G13_5).div(this.lineform5.service_year)).plus(this.G17_5).plus(this.G18_5).toString(); return ""; },
    G20_5() { if (this.C6_5 !== "" && this.C7_5 !== "" && this.C8_5 !== "" && this.C10_5 !== "") return this.$d(this.C6_5).times(this.C7_5).times(this.C8_5).times(this.C10_5).toString(); return ""; },
    G21_5() { if (this.G20_5 !== "" && this.G19_5 !== "") return this.$d(this.G20_5).minus(this.G19_5).toString(); return ""; },
    F28_5() { if (this.C17_5 !== "" && this.C18_5 !== "") return this.$d(this.C17_5).times(this.C18_5).toString(); return ""; },
    F30_5() {
      if (this.F28_5 !== "" && this.G21_5 !== "") {
        let v = this.$d(this.F28_5).div(this.G21_5);
        if (v.gt(0)) return v.toFixed(1);
      }
      return "-";
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
    cqpage() {
      this.getcqdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 380;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 380;
    };
    this.getdata();
  },
  methods: {
    changeTab(v, item) {
      console.log('changeTab', v);
      this.tab = v;
      if (v === 0) {
        this.getdata();
      }
      if (v === 1) {
        this.getcqdata();
      }
      if (v === 2) {
        this.gethangboxdata();
      }
      if (v === 3) {
        this.showcalc(item).then(() => {
          this.$nextTick(() => {
            this.$refs.calcform?.resetValidation();
          });
        });
      }
      if (v === 4) {
        this.showcalc5(item).then(() => {
          this.$nextTick(() => {
            this.$refs.calcform5?.resetValidation();
          });
        });
      }
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/calcline/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.vehicle_types = res.data.vehicle_types;
          this.vehicle_brands = res.data.vehicle_brands;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    initlineform() {
      return {
        _id: "",
        name: "",//线路名称
        km: "",//运距(km) <!--! C5
        day_tcount: "",//日均趟次 <!--! C6
        day_fcount: "",//日发班次 <!--! C7
        year_tdays: "",//年运输天数 <!--! C8
        service_year: "",//运营年限
        tbridge_cost: "",//单趟运输路桥费(元) <!--! C9
        tincome: "",//单班运输收入(元) <!--! C10
        departure_time: "",//发车时间(HH:mm)
        loading_time: "",//装车用时(小时)
        require_aging: "",//时效要求(小时)
        remark: "",
      };
    },
    showadd() {
      this.form = this.initlineform();
      this.modeltitle = "新增线路";
      this.saving = false;
      this.model = true;
    },
    showedit(item) {
      this.form = _.pick(item, _.keys(this.initlineform()));
      this.modeltitle = "编辑线路";
      this.saving = false;
      this.model = true;
    },
    copy(ids) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/calcline/copy", { ids }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          message.success("复制成功");
          this.selectedRowKeys = [];
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.saving = true;
      this.$api.doAPI("/calcline/save", { form: this.form }).then((res) => {
        this.$toast.clear();
        this.saving = false;
        if (res.code === 0) {
          message.success("保存成功");
          this.model = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        this.saving = false;
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/calcline/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    changeVehicleBrand(v) {
      console.log('changeVehicleBrand', v);
      this.showcalc({
        _id: this.detailform._id,
        lineid: this.lineform._id,
        vehicle_brand: v,
      }).then(() => {
        let brand = this.vehicle_brands2.find(n => n.value === v);
        if (brand.item) {
          let {
            F,//电池容量
            H,//工况续航
            I,//单车每公里耗电
            L,//单车采购价
          } = brand.item;
          if (F && !isNaN(Number(F))) {
            this.detailform.battery_capacity = F;
          }
          if (H && !isNaN(Number(H))) {
            this.detailform.working_condition_endurance = H;
          }
          if (I && !isNaN(Number(I))) {
            this.detailform.km_usepower = I;
          }
          if (L && !isNaN(Number(L))) {
            this.detailform.vehicle_price = this.$d(L).times(10000).toFixed(0);
          }
        }
      });
    },
    changeline(v) {
      this.showcalc({ _id: v });
    },
    showcalc(item) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/calcline/info", item).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.lines = res.data.lines;
          this.lineform = res.data.lineform;
          this.detailform = res.data.detailform;
          this.vehicle_brands2 = res.data.vehicle_brands;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    copydetail(id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/calcline/copydetail", { id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          message.success("复制成功");
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    savecalcresult() {
      if (!this.$refs.calcform.validate()) return;
      this.$toast.loading({ message: "" });
      this.saving = true;
      let form = {
        ...this.detailform,
        day_km: this.C21,
        year_km: this.C22,
        year_usepower: this.C25,
        year_totalpower: this.C26,
        vehicle_depreciation: this.G10,
        vehicle_insurance: this.G11,
        anisp_op: this.G12,
        vehicle_purchase_tax: this.G13,
        charge_service_fee: this.G4,
        electricity_fee: this.G5,
        road_bridge_fee: this.G6,
        vehicle_maintenance_fee: this.G7,
        tire_replacement_fee: this.G8,
        driver_salary: this.G14,
        manager_salary: this.G15,
        subsidy_benefits: this.G16,
        initial_investment: this.F28,
        year_income: this.G20,
        year_cost: this.G19,
        year_profit: this.G21,
        investment_return_years: this.F30,
      }
      this.$api.doAPI("/calcline/saveresult", { lineid: this.lineform._id, form }).then((res) => {
        this.$toast.clear();
        this.saving = false;
        if (res.code === 0) {
          message.success("保存成功");
          this.showcalc({ lineid: this.lineform._id, _id: res.data._id });
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        this.saving = false;
        console.error(err);
      });
    },
    // ===== 油车投资测算独立方法 =====
    changeVehicleBrand5(v) {
      console.log('changeVehicleBrand5', v);
      this.showcalc5({
        _id: this.detailform5._id,
        lineid: this.lineform5._id,
        vehicle_brand: v,
      }).then(() => {
        let brand = this.vehicle_brands5.find(n => n.value === v);
        if (brand.item) {
          let {
            F,//电池容量
            H,//工况续航
            I,//单车每公里耗电
            L,//单车采购价
          } = brand.item;
          if (F && !isNaN(Number(F))) {
            this.detailform5.battery_capacity = F;
          }
          if (H && !isNaN(Number(H))) {
            this.detailform5.working_condition_endurance = H;
          }
          if (I && !isNaN(Number(I))) {
            this.detailform5.km_usepower = I;
          }
          if (L && !isNaN(Number(L))) {
            this.detailform5.vehicle_price = this.$d(L).times(10000).toFixed(0);
          }
        }
      });
    },
    changeline5(v) {
      this.showcalc5({ _id: v });
    },
    showcalc5(item) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/calcline/info", item).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.lines = res.data.lines;
          this.lineform5 = res.data.lineform;
          this.detailform5 = res.data.detailform;
          this.vehicle_brands5 = res.data.vehicle_brands;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    savecalcresult5() {
      if (!this.$refs.calcform5.validate()) return;
      this.$toast.loading({ message: "" });
      this.saving5 = true;
      let form = {
        ...this.detailform5,
        day_km: this.C21_5,
        year_km: this.C22_5,
        year_usepower: this.C25_5,
        year_totalpower: this.C26_5,
        vehicle_depreciation: this.G10_5,
        vehicle_insurance: this.G11_5,
        anisp_op: this.G12_5,
        vehicle_purchase_tax: this.G13_5,
        charge_service_fee: this.G4_5,
        electricity_fee: this.G5_5,
        road_bridge_fee: this.G6_5,
        vehicle_maintenance_fee: this.G7_5,
        tire_replacement_fee: this.G8_5,
        driver_salary: this.G14_5,
        manager_salary: this.G15_5,
        subsidy_benefits: this.G16_5,
        initial_investment: this.F28_5,
        year_income: this.G20_5,
        year_cost: this.G19_5,
        year_profit: this.G21_5,
        investment_return_years: this.F30_5,
      }
      this.$api.doAPI("/calcline/saveresult", { lineid: this.lineform5._id, form }).then((res) => {
        this.$toast.clear();
        this.saving5 = false;
        if (res.code === 0) {
          message.success("保存成功");
          this.showcalc5({ lineid: this.lineform5._id, _id: res.data._id });
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        this.saving5 = false;
        console.error(err);
      });
    },
    getcqdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/automaker_financing/list", { page: this.cqpage, limit: this.cqlimit, ...this.cqQueryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.cqlist = res.data.list.map(n => {
            return {
              ...n,
              LT: this.$utils.d(n.L).plus(n.L1 || 0).toString(),
            }
          });
          this.cqlength = res.data.length;
          this.cqcount = res.data.count;
          if (this.cqlength > 0 && this.cqpage > this.cqlength) this.cqpage = 1;
          this.vehicle_brands = res.data.vehicle_brands;
          this.Bs = res.data.Bs;
          this.Cs = res.data.Cs;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    gethangboxdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/hangbox/list", { page: this.hangboxpage, limit: this.hangboxlimit }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.hangboxlist = res.data.list;
          this.hangboxlength = res.data.length;
          this.hangboxcount = res.data.count;
          if (this.hangboxlength > 0 && this.hangboxpage > this.hangboxlength) this.hangboxpage = 1;
          this.vehicle_types = res.data.vehicle_types;
          this.states = res.data.states;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    initcqform() {
      return {
        _id: "",
        A: undefined,
        B: "",
        C: "",
        D: "",
        E: "",
        F: "",
        G: "",
        H: "",
        I: "",
        J: "",
        K: "",
        L: "",
        L1: "",
        M: "",
        N: "",
      };
    },
    cqadd() {
      this.cqform = this.initcqform();
      this.cqtitle = "新增车企数据";
      this.cqmodal = true;
    },
    cqedit(item) {
      this.cqform = _.pick(item, _.keys(this.initcqform()));
      this.cqtitle = "编辑车企数据";
      this.cqmodal = true;
    },
    cqsave() {
      this.$refs.cqformref.validate(valid => {
        if (valid) {
          this.$toast.loading({ message: "" });
          this.$api.doAPI("/automaker_financing/save", { dataForm: this.cqform }).then((res) => {
            this.$toast.clear();
            if (res.code === 0) {
              this.cqmodal = false;
              this.getcqdata();
            }
            else {
              this.$alert(res.msg);
            }
          }).catch((err) => {
            this.$toast.clear();
            console.error(err);
          });
        }
        else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cqcancelsave() {
      this.$refs.cqformref.resetFields();
      this.cqmodal = false;
    },
    cqremove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/automaker_financing/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getcqdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cqbadd() {
      this.cqbform = {
        vehicle_brands: this.vehicle_brands.map(n => n.value).join('\n')
      };
      this.cqbtitle = "管理车企";
      this.cqbmodal = true;
    },
    cqbsave() {
      this.$refs.cqbformref.validate(valid => {
        if (valid) {
          this.$toast.loading({ message: "" });
          this.$api.doAPI("/automaker_financing/save_brands", this.cqbform).then((res) => {
            this.$toast.clear();
            if (res.code === 0) {
              this.cqbmodal = false;
              this.getcqdata();
            }
            else {
              this.$alert(res.msg);
            }
          }).catch((err) => {
            this.$toast.clear();
            console.error(err);
          });
        }
        else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cqbcancelsave() {
      this.$refs.cqbformref.resetFields();
      this.cqbmodal = false;
    },
    inithangboxform() {
      return {
        _id: "",
        A: "",
        B: "",
        C: "",
        D: "",
        E: "",
        F: "",
        H: "",
        G: ""
      };
    },
    ///新增挂箱数据
    hangboxadd() {
      this.hangboxform = this.inithangboxform();
      this.hangboxtitle = "新增挂箱数据";
      this.hangboxmodal = true;
    },
    ///编辑挂箱数据
    hangboxedit(item) {
      this.hangboxform = _.pick(item, _.keys(this.inithangboxform()));
      this.hangboxtitle = "编辑挂箱数据";
      this.hangboxmodal = true;
    },
    ///保存挂箱数据
    hangboxsave() {
      this.$refs.hangboxformref.validate(valid => {
        if (valid) {
          this.$toast.loading({ message: "" });
          this.$api.doAPI("/hangbox/save", { dataForm: this.hangboxform }).then((res) => {
            this.$toast.clear();
            if (res.code === 0) {
              this.hangboxmodal = false;
              this.gethangboxdata();
            }
            else {
              this.$alert(res.msg);
            }
          }).catch((err) => {
            this.$toast.clear();
            console.error(err);
          });
        }
        else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    ///取消挂箱数据保存
    hangboxcancelsave() {
      this.$refs.hangboxformref.resetFields();
      this.hangboxmodal = false;
    },
    ///删除挂箱数据
    hangboxremove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/hangbox/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.gethangboxdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>